import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
  type: null,
  isAuthenticatedUser: false
};

const userReducer = createReducer(initialState, {
  USER_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_LOGIN_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_LOGIN_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
    state.isAuthenticatedUser = payload.status;
    state.type = payload.data.user_type;
  },
  
  USER_REGISTER_SUC: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = actions.payload;
  },

  USER_LOGIN_FAIL: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
  USER_REFRESH_LOGIN_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
    state.isAuthenticatedUser = payload.status;
    state.type = payload.data.user_type;
  },
  USER_LOGOUT_REQ: (state) => {
    state.loading = true;
  },
  USER_LOGOUT_SUCCESS: (state) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
    state.isAuthenticatedUser = false;
    localStorage.clear();
  },
  USER_LOGOUT_FAIL: (state, actions) => {
    state.loading = false;
    state.error = actions.payload;
  },

  RESET_PSWD_FAIL: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = actions.payload;
  },
  USER_EMAIL_EXIST_SUC: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = actions.payload;
  },
  USER_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default userReducer;
